<template>
  <div>
    <!-- Container onde o leitor será renderizado -->
    <div id="reader" style="width: 300px;"></div>
  </div>
</template>

<script>
import { Html5QrcodeScanner } from "html5-qrcode";

export default {
  name: "QrCodeReader",
  mounted() {
    const config = { fps: 10, qrbox: 250 };
    // Callback chamado quando um QR Code é decodificado com sucesso
    const onScanSuccess = (decodedText, decodedResult) => {
      console.log("QR Code lido:", decodedText);
      console.log("QR Code lido:", decodedResult);
      // Aqui você pode tratar os dados do cupom fiscal
    };

    // Cria o scanner e renderiza dentro do elemento com id "reader"
    const html5QrcodeScanner = new Html5QrcodeScanner(
      "reader",
      config,
      /* verbose= */ false
    );
    html5QrcodeScanner.render(onScanSuccess);
  },
  beforeDestroy() {
    // Se necessário, adicione a lógica para parar o scanner ao destruir o componente
  }
};
</script>
